export const LAYOUT_CONTROLS = Object.freeze({
  repulsion: { label: "Répulsion", min: .1, max: 10000, step: .1, logarithmic: true, value: 20, hint: "Écarter les nœuds." },
  gravity: { label: "Gravité", min: 0, max: 100, step: .00001, logarithmic: true, value: .005, hint: "Ramener le réseau vers le centre." },
  attraction: { label: "Attraction", min: .01, max: 1000, step: .01, logarithmic: true, value: 50, hint: "Resserrer les liens au sein des grappes." },
  displayScale: { label: "Taille d’affichage", min: .4, max: 1.2, step: .05, value: .5, hint: "Nœuds et libellés, sans changer le zoom." },
});
export const DEFAULT_LAYOUT_SETTINGS = Object.freeze(Object.fromEntries(Object.entries(LAYOUT_CONTROLS).map(([key, c]) => [key, c.value])));
export function sanitizeLayoutSettings(settings = {}) {
  return Object.fromEntries(Object.entries(LAYOUT_CONTROLS).map(([key, c]) => {
    const value = typeof settings?.[key] === "number" && Number.isFinite(settings[key]) ? settings[key] : c.value;
    return [key, Number(Math.min(c.max, Math.max(c.min, Math.round(value / c.step) * c.step)).toFixed(6))];
  }));
}
export const LAYOUT_STORAGE_KEY = "entourages.layout.v1";
export function loadLayoutSettings(storage) {
  try { return sanitizeLayoutSettings(JSON.parse(storage.getItem(LAYOUT_STORAGE_KEY))); }
  catch { return { ...DEFAULT_LAYOUT_SETTINGS }; }
}
export function saveLayoutSettings(storage, settings) {
  try { storage.setItem(LAYOUT_STORAGE_KEY, JSON.stringify(sanitizeLayoutSettings(settings))); } catch { /* Private browsing/storage limits do not disable controls. */ }
}

// Equal travel means equal force ratios, not unusably coarse linear steps.
export const SLIDER_STEPS = 1000;
export function settingToSlider(key, value) {
  const c = LAYOUT_CONTROLS[key];
  if (!c.logarithmic) return value;
  if (value <= c.min) return 0;
  const floor = c.min || c.step;
  const offset = c.min === 0 ? 1 : 0;
  return offset + (SLIDER_STEPS - offset) * Math.log(value / floor) / Math.log(c.max / floor);
}
export function sliderToSetting(key, position) {
  const c = LAYOUT_CONTROLS[key];
  if (!c.logarithmic) return Number(position);
  const p = Math.min(SLIDER_STEPS, Math.max(0, Number(position)));
  if (p === 0) return c.min;
  const floor = c.min || c.step, offset = c.min === 0 ? 1 : 0;
  return floor * (c.max / floor) ** ((p - offset) / (SLIDER_STEPS - offset));
}
